import template from 'url-template';
import { get, isNil } from 'lodash';
import { Auth } from 'aws-amplify';

import { handleNetworkError,enqueueSnackbar } from './applicationMessageActions';
import awsHeader from '../helpers/awsAuth';
import k2aBaseApi from '../apis/key2act';
import {
    FETCH_BACKGROUND_JOBS,
    SET_BOB_LOADING
} from './actionTypes';

const ReportsUrl = template.parse('/worker-process-collection{?userId}');
const ReportsDeleteUrl = template.parse('/worker-process{?groupId,processId}');

export const fetchBackgroundJobs = (userId,companyId) => async (dispatch, getState) => {
    const { attributes } = await Auth.currentUserInfo();
    userId = attributes['custom:diAccountId'];
    
    const header = await awsHeader();
    if (isNil(companyId)) {
        companyId=attributes['custom:diDefaultCompanyId'];
        header.headers['K2A-Company'] = companyId;
    }
    else if (isNil(sessionStorage.getItem('companyId'))) {
        header.headers['K2A-Company'] = companyId;
    }
    
    dispatch(setBobLoading('BackgroundJobs'));
    try {
        const response = await k2aBaseApi.get(
            ReportsUrl.expand({
                userId
            }),
            header
        );

        const payload = get(response, 'data', '');

        payload.sort((a, b) => {
            return new Date(b.timestamp) - new Date(a.timestamp);
        });

        payload.forEach(c => {
            c.timestamp = new Date(c.timestamp);
            c.processType = c.processType.replace(/([A-Z])/g, ' $1').trim();
            c.status = c.status.replace(/([A-Z])/g, ' $1').trim();
        });
        dispatch({
            type: FETCH_BACKGROUND_JOBS,
            payload
        });

    } catch (error) {
        dispatch(handleNetworkError(error));
    } finally {
        dispatch(setBobLoading('BackgroundJobs'));
    }
};


export const deleteWorkerJob = (processId,groupId) => async (dispatch, getState) => {
    const header = await awsHeader();
    dispatch(setBobLoading('BackgroundJobs'));
    try {
        const response = await k2aBaseApi.delete(
            ReportsDeleteUrl.expand({
                groupId,
                processId
            }),
            header
        );
        dispatch(enqueueSnackbar('Background Job deleted successfully.', 'success'));

        return response;
    } catch (error) {
        dispatch(handleNetworkError(error));
        return false;
    }
    finally {
        dispatch(setBobLoading('BackgroundJobs'));
    }
};

export const deleteWorkerJobs = (ids) => async (dispatch, getState) => {
    const header = await awsHeader();
    dispatch(setBobLoading('BackgroundJobs'));
    try {
        for (let i=0;i<ids.length;i++) {
            const groupId =  ids[i].processGroupId;
            const processId = ids[i].processId;
            await k2aBaseApi.delete(
                ReportsDeleteUrl.expand({
                    groupId,
                    processId
                }),
                header
            );
        }
        dispatch(enqueueSnackbar('Background Jobs deleted successfully.', 'success'));
        return true;
    } catch (error) {
        dispatch(handleNetworkError(error));
        return false;
    }
    finally {
        dispatch(setBobLoading('BackgroundJobs'));
    }
};

export const setBobLoading = isLoading => async (dispatch, getState) => {
    let loadingArray = [...getState().bob.bobLoading];

    if (loadingArray.includes(isLoading)) {
        loadingArray = loadingArray.filter(item => item !== isLoading);
    } else {
        loadingArray.push(isLoading);
    }

    dispatch({
        type:    SET_BOB_LOADING,
        payload: [...loadingArray]
    });
};
